import trim from 'lodash/trim'
import uniq from 'lodash/uniq'
import qs from 'qs'

import {
  FINDOMESTIC_CHECKBOX_ASSICURAZIONI,
  FINDOMESTIC_CHECKBOX_CONTRATTO,
  FINDOMESTIC_CLEAR_FINANZIAMENTO_ASSICURATO,
  FINDOMESTIC_CODICI_ABITAZONE,
  FINDOMESTIC_CODICI_CARTA,
  FINDOMESTIC_CODICI_DESTINATARIO,
  FINDOMESTIC_CODICI_DOCUMENTO,
  FINDOMESTIC_CODICI_NAZIONALITA,
  FINDOMESTIC_CODICI_PAGAMENTO,
  FINDOMESTIC_CODICI_REPERIBILITA,
  FINDOMESTIC_CODICI_SCADENZA,
  FINDOMESTIC_CODICI_SETTORE_ATTIVITA,
  FINDOMESTIC_CODICI_STATOCIVILE,
  FINDOMESTIC_CODICI_TIPOASSICURAZIONE,
  FINDOMESTIC_CODICI_TIPODOCUMENTOSOGGIORNO,
  FINDOMESTIC_CODICI_TIPOLAVORO,
  FINDOMESTIC_CODICI_TIPOVEICOLO,
  FINDOMESTIC_CODICI_TITOLOSTUDIO,
  FINDOMESTIC_MAPPA_CODICI_LAVORO_SETTORI_ATTIVITA,
  FINDOMESTIC_SELECT_SERVIZIO_ASSICURATIVO,
  FINDOMESTIC_SET_DURATA_SERVIZIO_ASSICURATIVO,
  FINDOMESTIC_UNSELECT_ALL_SERVIZI_ASSICURATIVI,
  FINDOMESTIC_UNSELECT_SERVIZIO_ASSICURATIVO,
  FINDOMESTIC_UPDATE,
  FINDOMESTIC_UPDATE_DATI,
  GET_FINDOMESTIC_CHECK_FIRMA,
  GET_FINDOMESTIC_DOCUMENTI_CLIENTE_V1,
  GET_FINDOMESTIC_FIRMA_CONTRATTI,
  GET_FINDOMESTIC_PRODOTTI_ASSICURATIVI_FROM_ID_PIANO_RIMBORSO_OUTPUT,
  GET_FINDOMESTIC_SERVIZI_ASSICURATIVI,
  GET_INFOCERT_CERTIFICATO,
  INFOCERT_CHECKBOX_CERTIFICATO,
  INFOCERT_CHECKBOX_CONTRATTO,
  POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI,
  POST_FINDOMESTIC_DATI_CLIENTE_V1,
  POST_FINDOMESTIC_FIRMA_CONTRATTI,
  POST_FINDOMESTIC_FIRMA_PIN,
  POST_FINDOMESTIC_SET_PRATICA,
  POST_INFOCERT_CERTIFICATO,
  PUT_FINDOMESTIC_DATI_CLIENTE_V1,
  PUT_FINDOMESTIC_DATI_CLIENTE_V1_CONIUGE,
  RESET_FINDOMESTIC_PIN,
} from '../../constants/ActionTypes'
import {
  getCodiceServizioByUid,
  getCodiceTipoLavoro,
  getMensilitaCopertura,
  getModalitaServizioByUid,
  getServizioByUid,
  getSettoriPerProfessionistiARischio,
  residenzaPrecendenteRequired,
  showCostoAbitazione,
  showDataInizioAttivita,
  showDataScadenzaContratto,
  showDatiConiuge,
  showPaeseDiAttivita,
  showProfessionistiRischio,
  showReddito,
  showSedeLavoro,
} from '../../utils/findomesticUtils'
import { createBasicCreator, fetchData } from '../Buy'

export const getProdottiAssicurativiFromIdPianoRimborsoOutput = (
  dispatch,
  getState
) => {
  const { id_ordine } = getState().ordine
  const id_piano_rimborso_output =
    getState().findomestic.finanziamentoAssicurato.id_finanziamento

  const path = `/findomestic/t/v1/prodottiAssicurativi/${id_ordine}?id_piano_rimborso_output=${id_piano_rimborso_output}`

  const uri = `${window.brumbrum.url_api}${path}`

  return dispatch(
    fetchData(
      GET_FINDOMESTIC_PRODOTTI_ASSICURATIVI_FROM_ID_PIANO_RIMBORSO_OUTPUT
    )({
      callback:
        GET_FINDOMESTIC_PRODOTTI_ASSICURATIVI_FROM_ID_PIANO_RIMBORSO_OUTPUT,
      errorMessage:
        GET_FINDOMESTIC_PRODOTTI_ASSICURATIVI_FROM_ID_PIANO_RIMBORSO_OUTPUT,
      method: 'GET',
      uri,
    })
  )
}

export const postFindomesticCalcolatriceAssicurazioni = (
  dispatch,
  getState
) => {
  const { ordine } = getState()
  const { findomestic } = getState()
  const { financements } = getState()
  const prodotti_assicurativi =
    findomestic.servizi_assicurativi_selezionati.map(servizio => {
      const _servizio = getServizioByUid(
        servizio,
        findomestic.servizi_assicurativi
      )
      const durata = _servizio.selected_durata
      return {
        codice: getCodiceServizioByUid(servizio),
        modalita: getModalitaServizioByUid(servizio),
        durata:
          durata ||
          getMensilitaCopertura(
            _servizio,
            ordine,
            financements,
            findomestic
          ).pop(),
      }
    })
  const payload = {
    piano_rimborso_input: ordine.id_finanziamento,
    prodotti_assicurativi,
  }
  const uri = `${window.brumbrum.url_api}/findomestic/t/v1/calcolatriceAssicurazioni/${ordine.id_ordine}`
  return dispatch(
    fetchData(POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI)({
      body: JSON.stringify(payload),
      callback: POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI,
      errorMessage: POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI,
      method: 'POST',
      uri,
    })
  )
}

export const postFindomesticSetPratica = (dispatch, getState) => {
  const { ordine } = getState()
  const { findomestic } = getState()
  const payload = {
    // BRUM-8328 venivano mandati a findo ma ordini li ha gia'
    //      id_ordine: ordine.id_ordine,
    //      id_cliente: ordine.id_cliente || cliente.id_cliente,
    //      piano_rimborso: ordine.id_finanziamento,
    id_finanziamento: findomestic.finanziamentoAssicurato.id_finanziamento
      ? findomestic.finanziamentoAssicurato.id_finanziamento
      : ordine.id_finanziamento,
    servizi_extra: {
      findomestic: uniq(findomestic.servizi_assicurativi_selezionati).map(
        servizio => {
          const splitted = servizio.split('_')
          return Number(splitted[0])
        }
      ),
    },
  }
  // BRUM-8328 si passa da ordini
  // const uri = `${window.brumbrum.url_api}/findomestic/t/v1/pratiche`
  const uri = `${window.brumbrum.url_api}/ordini/t/v1/ordini/${ordine.id_ordine}`
  return dispatch(
    fetchData(POST_FINDOMESTIC_SET_PRATICA)({
      body: JSON.stringify(payload),
      callback: POST_FINDOMESTIC_SET_PRATICA,
      errorMessage: POST_FINDOMESTIC_SET_PRATICA,
      method: 'PUT',
      uri,
    })
  )
}

export const getFindomesticServiziAssicurativi = (dispatch, getState) => {
  const { ordine } = getState()
  const uri = `${window.brumbrum.url_api}/findomestic/t/v1/prodottiAssicurativi/${ordine.id_ordine}`
  return dispatch(
    fetchData(GET_FINDOMESTIC_SERVIZI_ASSICURATIVI)({
      callback: GET_FINDOMESTIC_SERVIZI_ASSICURATIVI,
      errorMessage: GET_FINDOMESTIC_SERVIZI_ASSICURATIVI,
      method: 'GET',
      uri,
      suppressErrorNotice: true,
    })
  )
}

export const postFindomesticDatiClienteV1 = (dispatch, getState) => {
  const state = getState()
  const findomesticDati = state.findomestic.dati
  const { ordine } = state
  const { customer } = state

  const payloadPut = {
    cc_IBAN: findomesticDati.iban,
    pep: customer.politicamente_esposto,
    domicilio_annoInizioAbitazione: findomesticDati.residente_dal.year,
    domicilio_tipoAbitazione: findomesticDati.situazione_abitativa,
    stato_civile: findomesticDati.stato_civile,
    cc_giornoapertura: findomesticDati.data_apertura_conto.day,
    cc_meseApertura: findomesticDati.data_apertura_conto.month,
    cc_annoApertura: findomesticDati.data_apertura_conto.year,
    flag675: findomesticDati.flag675,
    flagQualita: findomesticDati.flagQualita,
    flagPromozioni: findomesticDati.flagPromozioni,
    flagSocietaTerze: findomesticDati.flagSocietaTerze,
  }

  if (findomesticDati.seconda_cittadinanza) {
    payloadPut.seconda_cittadinanza_codice =
      findomesticDati.seconda_cittadinanza.split('|')[0]
  }

  if (residenzaPrecendenteRequired(findomesticDati)) {
    payloadPut.precedente_cap = findomesticDati.cap_precedente
    // comune_precedente Milano|MI|ITA|Milano (MI)|20133|2013.....
    payloadPut.precedente_localita =
      findomesticDati.comune_precedente.split('|')[0]
    payloadPut.precedente_provincia =
      findomesticDati.comune_precedente.split('|')[1]
    payloadPut.precedente_numeroCivico = findomesticDati.civico_precedente
    payloadPut.precedente_viaOPiazza = findomesticDati.indirizzo_precedente
  }

  if (showSedeLavoro(state.findomestic)) {
    payloadPut.lavoro_cap = findomesticDati.cap_lavoro
    payloadPut.lavoro_numeroCivico = findomesticDati.civico_lavoro
    // comune_lavoro Milano|MI|ITA|Milano (MI)|20133|2013.....
    payloadPut.lavoro_localita = findomesticDati.comune_lavoro.split('|')[0]
    payloadPut.lavoro_provincia = findomesticDati.comune_lavoro.split('|')[1]
    payloadPut.lavoro_datoreLavoro = findomesticDati.datore_lavoro
    payloadPut.lavoro_viaOPiazza = findomesticDati.indirizzo_lavoro
    payloadPut.telefonoLavoro = findomesticDati.telefono_fisso_lavoro
  }

  if (showDataInizioAttivita(state.findomestic)) {
    payloadPut.lavoro_meseInizio = findomesticDati.data_inizio_attivita.month
    payloadPut.lavoro_annoInizio = findomesticDati.data_inizio_attivita.year
  }

  if (showDataScadenzaContratto(state.findomestic)) {
    payloadPut.lavoro_dataScadenzaContratto =
      findomesticDati.data_scadenza_contratto.raw
    payloadPut.lavoro_isContrattoTempoDeterminato = 1
  } else {
    payloadPut.lavoro_isContrattoTempoDeterminato = 0
  }

  if (showCostoAbitazione(findomesticDati)) {
    payloadPut.domicilio_costoAbitazione = findomesticDati.costo_abitazione
  }

  if (
    showPaeseDiAttivita(findomesticDati) &&
    findomesticDati.paese_di_attivita_principale
  ) {
    payloadPut.lavoro_paeseAttivita =
      findomesticDati.paese_di_attivita_principale.split('|')[2]
  }

  const codiceTipoLavoro = getCodiceTipoLavoro(state.findomestic)

  if (codiceTipoLavoro.length === 1) {
    payloadPut.lavoro_codice = codiceTipoLavoro[0].id
  } else {
    // mando volontariamente errore
    /* eslint-disable */
    payloadPut.lavoro_codice_err = {
      codiceTipoLavoro,
      situazioneLavorativa,
      settore,
      occupazione,
    }
    /* eslint-enable */
  }

  if (showReddito(state.findomestic)) {
    payloadPut.lavoro_reddito = findomesticDati.reddito_mensile_lavoro
  }

  if (customer.documento === 'Patente') {
    payloadPut.documento_retroPatente =
      findomesticDati.numero_documento_retro_patente
  }

  const payloadPutConiuge = {}
  if (showDatiConiuge(state.findomestic)) {
    if (showReddito(state.findomestic, true)) {
      payloadPutConiuge.lavoro_reddito =
        findomesticDati.coniuge_reddito_mensile_lavoro
    }

    if (showDataInizioAttivita(state.findomestic, true)) {
      payloadPutConiuge.lavoro_meseInizio =
        findomesticDati.coniuge_data_inizio_attivita.month
      payloadPutConiuge.lavoro_annoInizio =
        findomesticDati.coniuge_data_inizio_attivita.year
    }

    if (showDataScadenzaContratto(state.findomestic, true)) {
      payloadPutConiuge.lavoro_dataScadenzaContratto =
        findomesticDati.coniuge_data_scadenza_contratto.raw
      payloadPutConiuge.lavoro_isContrattoTempoDeterminato = 1
    } else {
      payloadPutConiuge.lavoro_isContrattoTempoDeterminato = 0
    }

    if (showProfessionistiRischio(state.findomestic, true)) {
      // l'utente ha selezionato un valore dalla tendina
      payloadPutConiuge.lavoro_settoreAttivita =
        state.findomestic.CodiciSettoreAttivitaById[
          findomesticDati.coniuge_settore_rischio_aml
        ].codice
    } else {
      // o si prende il valore di default se presente una sola opzione
      const settori = getSettoriPerProfessionistiARischio(
        state.findomestic,
        true
      )
      if (settori.length === 1) {
        payloadPutConiuge.lavoro_settoreAttivita = settori[0].codice
      }
    }

    const situazioneLavorativaConiuge = trim(
      findomesticDati.coniuge_situazione_lavorativa
    )
    const settoreConiuge = trim(
      findomesticDati.coniuge_settore ||
        state.findomestic.settoreBySituazione[situazioneLavorativaConiuge][0]
          .value
    )
    const occupazioneConiuge = trim(
      findomesticDati.coniuge_occupazione ||
        state.findomestic.occupazioneBySituazioneAndSettore[
          `${situazioneLavorativaConiuge}_${settoreConiuge}`
        ][0].value
    )

    const codiceTipoLavoroConiuge = state.findomestic.CodiciTipoLavoro.filter(
      codice => {
        const isParent1 = situazioneLavorativaConiuge === trim(codice.parent_1)
        const isParent2 = settoreConiuge === trim(codice.parent_2)
        const isDescrizione = occupazioneConiuge === trim(codice.descrizione)

        return isParent1 && isParent2 && isDescrizione
      }
    )

    if (codiceTipoLavoroConiuge.length === 1) {
      payloadPutConiuge.lavoro_codice = codiceTipoLavoroConiuge[0].id
    } else {
      // mando volontariamente errore
      payloadPutConiuge.lavoro_codice_err = {
        codiceTipoLavoroConiuge,
        situazioneLavorativaConiuge,
        settoreConiuge,
        occupazioneConiuge,
      }
    }
  }

  if (showProfessionistiRischio(state.findomestic)) {
    // l'utente ha selezionato un valore dalla tendina
    payloadPut.lavoro_settoreAttivita =
      state.findomestic.CodiciSettoreAttivitaById[
        findomesticDati.settore_rischio_aml
      ].codice
  } else {
    // o si prende il valore di default se presente una sola opzione
    const settori = getSettoriPerProfessionistiARischio(state.findomestic)
    if (settori.length === 1) {
      payloadPut.lavoro_settoreAttivita = settori[0].codice
    }
  }

  const uri = `${window.brumbrum.url_api}/findomestic/t/v1/clienti`

  const postClienteFindomestic = fetchData(POST_FINDOMESTIC_DATI_CLIENTE_V1)({
    body: JSON.stringify({ id_ordine: ordine.id_ordine }),
    callback: POST_FINDOMESTIC_DATI_CLIENTE_V1,
    errorMessage: POST_FINDOMESTIC_DATI_CLIENTE_V1,
    method: 'POST',
    uri,
  })

  const noPostClienteFindomestic = () =>
    new Promise(resolve => {
      resolve({
        result: {
          id_cliente: findomesticDati.idCliente,
        },
      })
    })

  /**
   * BRUM-5813
   * se ho gia' creato il cliente in db findo
   * non lo ricreo piu' e lo aggiorno
   */
  const dispatchThis = findomesticDati.idCliente
    ? noPostClienteFindomestic
    : postClienteFindomestic

  return new Promise((resolve, reject) => {
    dispatch(dispatchThis)
      .then(json => {
        dispatch(
          fetchData(PUT_FINDOMESTIC_DATI_CLIENTE_V1)({
            body: JSON.stringify(payloadPut),
            callback: PUT_FINDOMESTIC_DATI_CLIENTE_V1,
            errorMessage: PUT_FINDOMESTIC_DATI_CLIENTE_V1,
            method: 'PUT',
            uri: `${uri}/${json.result.id_cliente}/T`,
          })
        ).then(_json => {
          if (!showDatiConiuge(state.findomestic)) {
            resolve(_json)
          } else {
            dispatch(
              fetchData(PUT_FINDOMESTIC_DATI_CLIENTE_V1_CONIUGE)({
                body: JSON.stringify(payloadPutConiuge),
                callback: PUT_FINDOMESTIC_DATI_CLIENTE_V1_CONIUGE,
                errorMessage: PUT_FINDOMESTIC_DATI_CLIENTE_V1_CONIUGE,
                method: 'PUT',
                uri: `${uri}/${json.result.id_cliente}/C`,
              })
            ).then(__json => {
              resolve({ ..._json, ...__json })
            })
          }
        })
      })
      .catch(ex => reject(ex))
  })
}

export const findomesticTabelleDominio = (dispatch, getState) => {
  const tabelleDominio = {
    CodiciAbitazione: FINDOMESTIC_CODICI_ABITAZONE,
    CodiciCarta: FINDOMESTIC_CODICI_CARTA,
    CodiciDestinatario: FINDOMESTIC_CODICI_DESTINATARIO,
    CodiciDocumento: FINDOMESTIC_CODICI_DOCUMENTO,
    CodiciNazionalita: FINDOMESTIC_CODICI_NAZIONALITA,
    CodiciPagamento: FINDOMESTIC_CODICI_PAGAMENTO,
    CodiciReperibilita: FINDOMESTIC_CODICI_REPERIBILITA,
    CodiciScadenza: FINDOMESTIC_CODICI_SCADENZA,
    CodiciStatoCivile: FINDOMESTIC_CODICI_STATOCIVILE,
    CodiciTipoAssicurazione: FINDOMESTIC_CODICI_TIPOASSICURAZIONE,
    CodiciTipoDocumentoSoggiorno: FINDOMESTIC_CODICI_TIPODOCUMENTOSOGGIORNO,
    CodiciTipoLavoro: FINDOMESTIC_CODICI_TIPOLAVORO,
    CodiciTipoVeicolo: FINDOMESTIC_CODICI_TIPOVEICOLO,
    CodiciTitoloStudio: FINDOMESTIC_CODICI_TITOLOSTUDIO,
    MappaCodiciLavoroSettoriAttivita:
      FINDOMESTIC_MAPPA_CODICI_LAVORO_SETTORI_ATTIVITA,
    CodiciSettoreAttivita: FINDOMESTIC_CODICI_SETTORE_ATTIVITA,
  }

  const currentState = getState().findomestic

  const tabelleDominioRequests = []

  const baseUri = `${window.brumbrum.url_api}/findomestic/t/v1/tabelle-dominio`

  // eslint-disable-next-line
  for (const nomeTabella in tabelleDominio) {
    const actionType = tabelleDominio[nomeTabella]

    // posso controllare direttamente length perche' l'initial state e' []
    if (currentState[nomeTabella].length === 0) {
      // manca questa tabella di dominio, fetch it!

      const uri = `${baseUri}/${nomeTabella}`

      tabelleDominioRequests.push(
        dispatch(
          fetchData(actionType)({
            uri,
            method: 'GET',
            callback: actionType,
            errorMessage: actionType,
          })
        )
      )
    }
  }

  return Promise.all(tabelleDominioRequests)
}

export const findomesticUpdateDati = createBasicCreator(FINDOMESTIC_UPDATE_DATI)
export const findomesticUpdate = createBasicCreator(FINDOMESTIC_UPDATE)
export const findomesticCheckBoxContratto = createBasicCreator(
  FINDOMESTIC_CHECKBOX_CONTRATTO
)
export const findomesticCheckBoxAssicurazioni = createBasicCreator(
  FINDOMESTIC_CHECKBOX_ASSICURAZIONI
)
export const infocertCheckBoxCertificato = createBasicCreator(
  INFOCERT_CHECKBOX_CERTIFICATO
)
export const infocertCheckBoxContratto = createBasicCreator(
  INFOCERT_CHECKBOX_CONTRATTO
)
export const findomesticResetPin = createBasicCreator(RESET_FINDOMESTIC_PIN)
export const unSelectServizioAssicurativo = createBasicCreator(
  FINDOMESTIC_UNSELECT_SERVIZIO_ASSICURATIVO
)
export const unSelectAllServiziAssicurativi = createBasicCreator(
  FINDOMESTIC_UNSELECT_ALL_SERVIZI_ASSICURATIVI
)
export const selectServizioAssicurativo = createBasicCreator(
  FINDOMESTIC_SELECT_SERVIZIO_ASSICURATIVO
)
export const clearFinanziamentoAssicurato = createBasicCreator(
  FINDOMESTIC_CLEAR_FINANZIAMENTO_ASSICURATO
)
export const setDurataServizioAssicurativo = createBasicCreator(
  FINDOMESTIC_SET_DURATA_SERVIZIO_ASSICURATIVO
)

export const getFindomesticDocumentiClienteV1 = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine

  const uri = `${window.brumbrum.url_api}/findomestic/t/v1/documenti/${idOrdine}`
  return dispatch(
    fetchData(GET_FINDOMESTIC_DOCUMENTI_CLIENTE_V1)({
      callback: GET_FINDOMESTIC_DOCUMENTI_CLIENTE_V1,
      errorMessage: GET_FINDOMESTIC_DOCUMENTI_CLIENTE_V1,
      method: 'GET',
      uri,
    })
  )
}

export const findomesticCheckFirma = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine

  const uri = `${window.brumbrum.url_api}/findomestic/t/v1/firma/${idOrdine}/check`
  return dispatch(
    fetchData(GET_FINDOMESTIC_CHECK_FIRMA)({
      callback: GET_FINDOMESTIC_CHECK_FIRMA,
      errorMessage: GET_FINDOMESTIC_CHECK_FIRMA,
      method: 'GET',
      uri,
    })
  )
}

export const getInfocertCertificato = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine

  const uri = `${window.brumbrum.url_api}/findomestic/t/v1/firma/${idOrdine}/certificato`
  return dispatch(
    fetchData(GET_INFOCERT_CERTIFICATO)({
      callback: GET_INFOCERT_CERTIFICATO,
      errorMessage: GET_INFOCERT_CERTIFICATO,
      method: 'GET',
      uri,
    })
  )
}

export const postInfocertCertificato = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine
  const body = {
    ...state.findomestic.certificatoCheckBoxes,
    credentials: state.findomestic.credentials,
  }

  const uri = `${window.brumbrum.url_api}/findomestic/t/v1/firma/${idOrdine}/certificato`
  return dispatch(
    fetchData(POST_INFOCERT_CERTIFICATO)({
      callback: POST_INFOCERT_CERTIFICATO,
      errorMessage: POST_INFOCERT_CERTIFICATO,
      method: 'POST',
      uri,
      body: JSON.stringify(body),
    })
  )
}

export const getContratti = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine
  const params = {
    pin: state.findomestic.pin,
    conferma_pin: state.findomestic.conferma_pin,
    otp: state.findomestic.otp,
    ...state.findomestic.credentials,
  }

  const uri = `${
    window.brumbrum.url_api
  }/findomestic/t/v1/firma/${idOrdine}/contratti?${qs.stringify(params)}`
  return dispatch(
    fetchData(GET_FINDOMESTIC_FIRMA_CONTRATTI)({
      callback: GET_FINDOMESTIC_FIRMA_CONTRATTI,
      errorMessage: GET_FINDOMESTIC_FIRMA_CONTRATTI,
      method: 'GET',
      uri,
    })
  )
}

/**
 * Triggera esclusivamente l'invio dell'OTP
 */
export const postFindomesticFirmaPin = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine
  const body = {
    credentials: state.findomestic.credentials,
  }

  const uri = `${window.brumbrum.url_api}/findomestic/t/v1/firma/${idOrdine}/firma-pin`
  return dispatch(
    fetchData(POST_FINDOMESTIC_FIRMA_PIN)({
      callback: POST_FINDOMESTIC_FIRMA_PIN,
      errorMessage: POST_FINDOMESTIC_FIRMA_PIN,
      method: 'POST',
      uri,
      body: JSON.stringify(body),
    })
  )
}

export const postContratti = (dispatch, getState) => {
  const state = getState()
  const { ordine } = state
  const idOrdine = ordine.id_ordine
  const assicurazioni = state.findomestic.firmaAssicurazioni.reduce(
    (acc, el) => {
      const assKey = el.key
      acc[`assicurazioni_${assKey}`] = Object.values(
        state.findomestic.firmaAssicurazioniCheckBoxes
      ).reduce((_acc, _el) => {
        const _assKey = _el.key
        // prendo solo le checkbox dell'assicurazione che sto riducendo
        if (_assKey.indexOf(assKey) === 0) {
          const checkKey = _assKey.replace(`${assKey}_`, '')
          _acc[checkKey] = { accepted: _el.accepted }
        }
        return _acc
      }, {})

      acc[`assicurazioni_${assKey}`].id = el.links[0].id

      return acc
    },
    {}
  )

  const body = {
    pin: state.findomestic.pin,
    otp: state.findomestic.otp,
    infocert: {
      ...state.findomestic.contrattoInfocertCheckBoxes,
      id: state.findomestic.contrattoInfocertLinks[0].id,
    },
    findomestic: {
      ...state.findomestic.contrattoFindomesticCheckBoxes,
      id: state.findomestic.contrattoFindomesticLinks[0].id,
    },
    credentials: state.findomestic.credentials,
    ...assicurazioni,
  }

  const uri = `${window.brumbrum.url_api}/findomestic/t/v1/firma/${idOrdine}/contratti`
  return dispatch(
    fetchData(POST_FINDOMESTIC_FIRMA_CONTRATTI)({
      callback: POST_FINDOMESTIC_FIRMA_CONTRATTI,
      errorMessage: POST_FINDOMESTIC_FIRMA_CONTRATTI,
      method: 'POST',
      uri,
      body: JSON.stringify(body),
    })
  )
}
